import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";
import {CurrentRouteService} from "../../currentRoute.service";
import {AccountIdService, AccountNameService, AgencyIdService} from "../../account.service";
import {ApiService} from "../../api_service/api.service";
import {AccountsService} from "../../accounts/accounts.service";
import {SnackBarService} from "../../snackBar.service";
import {IntegrationProviderService} from "../integration-provider.service";
import * as _ from "lodash";

import {DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import {ThemePalette} from '@angular/material/core';

import {Observable, interval, pipe, } from 'rxjs';
import { switchMap,takeWhile } from 'rxjs/operators';


export interface GoogleadsPostInterfaceData {
  serviceName: string
}

@Component({
  selector: 'app-integrations-googleads',
  templateUrl: './integrations-googleads.component.html',
  styleUrls: ['./integrations-googleads.component.css']
})
export class IntegrationsGoogleadsComponent implements OnInit {

  helps = [
    "If the Reauthorize button is visible and connected is false then Reauthorize"
  ]

  agency_id: string;
  account_id: string;
  data = {};
  is_refresh_token: boolean = false;
  checked = false;
  color: ThemePalette = 'primary';
  is_loading = false;
  is_redirect_url = false;

  safeUrl: SafeResourceUrl;
  //url: string = "https://accounts.google.com/o/oauth2/auth?response_type=code&client_id=686286450747-1u56qiiei8o3e98bgs4edt180vn2k0ma.apps.googleusercontent.com&redirect_uri=https://devwebhook.angleattribution.com/webhooks/googleads/add&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fadwords&state=whe5dd601d5b9e44cc8d20efbad0d3233e&prompt=consent&access_type=offline";
  url: string;
  webhook_id: string;

  constructor(public router: Router,
              public route: ActivatedRoute,
              public dialog: MatDialog,
              private currentrouteService: CurrentRouteService,
              private agencyidService: AgencyIdService,
              private accountidService: AccountIdService,
              private accountnameService: AccountNameService,
              private _integrationProviderService: IntegrationProviderService,
              private sanitizer: DomSanitizer
  ) {
  }

  ngOnInit(): void {

    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);

    this.currentrouteService.announceCurrentRoute(this.router.url);

    this.route.params.subscribe(parms => {
      this.agency_id = parms['agency_id'],
        this.account_id = parms['account_id'],
        this.agencyidService.announceAgencyId(this.agency_id);
      this.accountidService.announceAccountId(this.account_id);
      this.load_data();
      //this.pollUntillCompleted();
    });

  } // end of ngOnInit

  goBack() {
    window.history.back();
  } // end of goBack

  isStatusCheckRunning
  pollUntillCompleted() {

    //https://www.learnrxjs.io/learn-rxjs/operators/transformation/switchmap

    let endpoint = `webhooks/account/${this.account_id}`;

    const subscription = interval(5000)
      .pipe(
        switchMap(() =>
          //this.apiService.getStatus()
          this._integrationProviderService.get(endpoint)
        ),
        takeWhile(({ status }) => {
          console.log('wtf!!!!',status);
          return !this.isStatusCompleted(status);
        })
      )
      .subscribe(
        _ => {},
        _ => {},
        () => {
          this.isStatusCheckRunning = false;
          //this.apiService.reloadData();
        }
      );

  } // end of pollUntillCompleted

  isStatusCompleted(status) {
    console.log('status wow 200', status);
    return status.status === 'completed';
  }

  polllingTokenRefreshService() {

    // https://stackoverflow.com/questions/63058012/angular-rxjs-poll-http-request-until-timeout-or-positive-response-from-server



    // interval(10000).subscribe(x => {
    // }) // end of interval

  } //end polllingCallService

  onPop() {
    window.open(this.url, 'popup', 'width=600,height=600');
    console.log('wow!!!!!!!')
  }

  load_data() {

    /*
        {
        "serviceName": "googleads",
        "customer_client_id": "1234-1234-1234",
        "Id": "whe5dd601d5b9e44cc8d20efbad0d3233e",
        "webhook_id": "whe5dd601d5b9e44cc8d20efbad0d3233e",
        "account_id": "acctb669bd39494548989eb146cd3f6ddec3",
        "redirect_url": "https://accounts.google.com/o/oauth2/auth?response_type=code&client_id=686286450747-1u56qiiei8o3e98bgs4edt180vn2k0ma.apps.googleusercontent.com&redirect_uri=https://devwebhook.angleattribution.com/webhooks/googleads/add&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fadwords&state=whe5dd601d5b9e44cc8d20efbad0d3233e&prompt=consent&access_type=offline",
        "refresh_token": "1//0df50YF5FlFlKCgYIARAAGA0SNwF-L9IrUbwY8uVc1SG-23eLQivosuvpZlAskt1dO76SMlR08ry2ik_o-ltU9LxvUUgJAILGVUo",
        "access_token": "ya29.A0ARrdaM_lZVpjHhNik93Og4ox2BQKAjgb5Lpnw9DOw9xTT7SziJxI2Zg4H7IAGCZFfrCP0uMlO60totg5eSy7_kGeTzge8NpHzPWLJLB_UiO_K9TPpNgPHRNNK9274etsx883dNpaxYA7l4nG0PmxmgVzXyeD"
      }
     */

    this.is_redirect_url = false;
    this.webhook_id = null;
    this.checked = false;
    this.is_loading = true
    let endpoint = `webhooks/account/${this.account_id}`;

    let fu = this._integrationProviderService.get(endpoint).subscribe(x => {
      console.log('!!!!!!!!!!!!', _.isEmpty(x['body']))


      if (_.isEmpty(x['body'])) {
        //this.is_data = true
      } else {
        for (const [cn, v] of Object.entries(x['body'])) {
          console.log(cn, v);
          if (v['serviceName'] == 'googleads') {
            this.webhook_id = v['webhook_id']
            if (v['is_connected'] == 'false'){
              this.checked = false;
            } else {
              this.checked = true;
            }
            console.log(v['redirect_url'])
            this.data = v;
          }
          //this.global_object[cn] = v
          //this.adwords_accounts.push(cn);
          //this.adwords_accounts_object[cn] = v;
        }
        //this.campaign_name_list = this.global_object['campaign_name_list']
      }


      if ('redirect_url' in this.data) {
        this.is_redirect_url = true;
      } else {
        this.checked = false;
      }


      if ('refresh_token' in this.data) {
        this.is_refresh_token = true;
      }
      if ('redirect_url' in this.data) {
        this.url = this.data['redirect_url']
      }

      this.is_loading = false;


    }, error => {
      console.log('ERROR ', error)
      this.is_loading = false;
    }); //end apiService

  } //end load_data

  onDelete(){

    let endpoint = `webhooks/${this.webhook_id}`;
    let fu = this._integrationProviderService.delete(endpoint).subscribe(x => {
      this.is_redirect_url = false;
      this.webhook_id = null;
      this.checked = false;
      this.load_data();
    }, error => {
      console.log('ERROR ', error)
      this.is_loading = false;
    }); //end _integrationProviderService.delete

  } //end onDelete


  submit() {
    let endpoint = `webhooks/account/${this.account_id}`
    console.log(endpoint)
    let data: GoogleadsPostInterfaceData = {serviceName: 'googleads'}
    this._integrationProviderService.post_googleads(endpoint, data).subscribe(x => {
      console.log(x)
      this.url = x['body']['redirect_url']
      this.webhook_id = x['body']['webhook_id']
      this.onPop()
      //this.load_data()
    }); //end post


  } // end of submit

} // end of class


@Component({
  selector: 'dialog-content-example-dialog',
  templateUrl: 'integration-dialog.html',
  styleUrls: []
})
export class AddIntegratinsGoogleAdsDialog implements OnInit {
  safeUrl: SafeResourceUrl;
  url: string = "https://accounts.google.com/o/oauth2/auth?response_type=code&client_id=686286450747-1u56qiiei8o3e98bgs4edt180vn2k0ma.apps.googleusercontent.com&redirect_uri=https://devwebhook.angleattribution.com/webhooks/googleads/add&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fadwords&state=whe5dd601d5b9e44cc8d20efbad0d3233e&prompt=consent&access_type=offline";

  constructor(private sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
  }
}
